/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M12 9L12 22M2 9H22M2 15H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 9H22V15.6C22 17.8402 22 18.9603 21.564 19.816C21.1805 20.5686 20.5686 21.1805 19.816 21.564C18.9603 22 17.8402 22 15.6 22H8.4C6.15979 22 5.03969 22 4.18404 21.564C3.43139 21.1805 2.81947 20.5686 2.43597 19.816C2 18.9603 2 17.8402 2 15.6V9Z"
				fill="currentColor"
			/>
			<path
				d="M12 9V15M12 9H2M12 9H22M12 15L12 22M12 15H2M12 15H22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.91667 1.25C6.36671 1.25 5.59174 1.25 4.9559 1.42037C3.23044 1.88271 1.88271 3.23044 1.42037 4.9559C1.25 5.59174 1.25 6.36671 1.25 7.91667C1.25 8.22666 1.25 8.38165 1.28407 8.50882C1.37654 8.85391 1.64609 9.12346 1.99118 9.21593C2.11835 9.25 2.27334 9.25 2.58333 9.25H12H21.4167C21.7267 9.25 21.8817 9.25 22.0088 9.21593C22.3539 9.12346 22.6235 8.85391 22.7159 8.50882C22.75 8.38165 22.75 8.22666 22.75 7.91667C22.75 6.36671 22.75 5.59174 22.5796 4.9559C22.1173 3.23044 20.7696 1.88271 19.0441 1.42037C18.4083 1.25 17.6333 1.25 16.0833 1.25H7.91667ZM2.85 15.75C2.28995 15.75 2.00992 15.75 1.79601 15.641C1.60785 15.5451 1.45487 15.3922 1.35899 15.204C1.25 14.9901 1.25 14.7101 1.25 14.15V12.35C1.25 11.7899 1.25 11.5099 1.35899 11.296C1.45487 11.1078 1.60785 10.9549 1.79601 10.859C2.00992 10.75 2.28995 10.75 2.85 10.75H9.65C10.2101 10.75 10.4901 10.75 10.704 10.859C10.8922 10.9549 11.0451 11.1078 11.141 11.296C11.25 11.5099 11.25 11.7899 11.25 12.35V14.15C11.25 14.7101 11.25 14.9901 11.141 15.204C11.0451 15.3922 10.8922 15.5451 10.704 15.641C10.4901 15.75 10.2101 15.75 9.65 15.75H2.85ZM2.16667 17.25C1.66041 17.25 1.25 17.6604 1.25 18.1667C1.25 20.698 3.30203 22.75 5.83333 22.75H9.65C10.2101 22.75 10.4901 22.75 10.704 22.641C10.8922 22.5451 11.0451 22.3922 11.141 22.204C11.25 21.9901 11.25 21.7101 11.25 21.15V18.85C11.25 18.2899 11.25 18.0099 11.141 17.796C11.0451 17.6078 10.8922 17.4549 10.704 17.359C10.4901 17.25 10.2101 17.25 9.65 17.25H2.16667ZM14.35 17.25C13.7899 17.25 13.5099 17.25 13.296 17.359C13.1078 17.4549 12.9549 17.6078 12.859 17.796C12.75 18.0099 12.75 18.2899 12.75 18.85V21.15C12.75 21.7101 12.75 21.9901 12.859 22.204C12.9549 22.3922 13.1078 22.5451 13.296 22.641C13.5099 22.75 13.7899 22.75 14.35 22.75H18.1667C20.698 22.75 22.75 20.698 22.75 18.1667C22.75 17.6604 22.3396 17.25 21.8333 17.25H14.35ZM21.15 15.75C21.7101 15.75 21.9901 15.75 22.204 15.641C22.3922 15.5451 22.5451 15.3922 22.641 15.204C22.75 14.9901 22.75 14.7101 22.75 14.15V12.35C22.75 11.7899 22.75 11.5099 22.641 11.296C22.5451 11.1078 22.3922 10.9549 22.204 10.859C21.9901 10.75 21.7101 10.75 21.15 10.75H14.35C13.7899 10.75 13.5099 10.75 13.296 10.859C13.1078 10.9549 12.9549 11.1078 12.859 11.296C12.75 11.5099 12.75 11.7899 12.75 12.35V14.15C12.75 14.7101 12.75 14.9901 12.859 15.204C12.9549 15.3922 13.1078 15.5451 13.296 15.641C13.5099 15.75 13.7899 15.75 14.35 15.75H21.15Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M12 9L12 22M6 9H22V14C22 16.8003 22 18.2004 21.455 19.27C20.9757 20.2108 20.2108 20.9757 19.27 21.455C18.2004 22 16.8003 22 14 22H10C7.19974 22 5.79961 22 4.73005 21.455C3.78924 20.9757 3.02433 20.2108 2.54497 19.27C2 18.2004 2 16.8003 2 14V10C2 7.19974 2 5.79961 2.54497 4.73005C3.02433 3.78924 3.78924 3.02433 4.73005 2.54497C5.79961 2 7.19974 2 10 2H14C16.8003 2 18.2004 2 19.27 2.54497C20.2108 3.02433 20.9757 3.78924 21.455 4.73005M2 15H22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M12 9L12 22M2 9H22M2 15H22M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.85 15.75C2.28995 15.75 2.00992 15.75 1.79601 15.641C1.60785 15.5451 1.45487 15.3922 1.35899 15.204C1.25 14.9901 1.25 14.7101 1.25 14.15V12.35C1.25 11.7899 1.25 11.5099 1.35899 11.296C1.45487 11.1078 1.60785 10.9549 1.79601 10.859C2.00992 10.75 2.28995 10.75 2.85 10.75H9.65C10.2101 10.75 10.4901 10.75 10.704 10.859C10.8922 10.9549 11.0451 11.1078 11.141 11.296C11.25 11.5099 11.25 11.7899 11.25 12.35V14.15C11.25 14.7101 11.25 14.9901 11.141 15.204C11.0451 15.3922 10.8922 15.5451 10.704 15.641C10.4901 15.75 10.2101 15.75 9.65 15.75H2.85ZM2.16667 17.25C1.66041 17.25 1.25 17.6604 1.25 18.1667C1.25 20.698 3.30203 22.75 5.83333 22.75H9.65C10.2101 22.75 10.4901 22.75 10.704 22.641C10.8922 22.5451 11.0451 22.3922 11.141 22.204C11.25 21.9901 11.25 21.7101 11.25 21.15V18.85C11.25 18.2899 11.25 18.0099 11.141 17.796C11.0451 17.6078 10.8922 17.4549 10.704 17.359C10.4901 17.25 10.2101 17.25 9.65 17.25H2.16667ZM14.35 17.25C13.7899 17.25 13.5099 17.25 13.296 17.359C13.1078 17.4549 12.9549 17.6078 12.859 17.796C12.75 18.0099 12.75 18.2899 12.75 18.85V21.15C12.75 21.7101 12.75 21.9901 12.859 22.204C12.9549 22.3922 13.1078 22.5451 13.296 22.641C13.5099 22.75 13.7899 22.75 14.35 22.75H18.1667C20.698 22.75 22.75 20.698 22.75 18.1667C22.75 17.6604 22.3396 17.25 21.8333 17.25H14.35ZM21.15 15.75C21.7101 15.75 21.9901 15.75 22.204 15.641C22.3922 15.5451 22.5451 15.3922 22.641 15.204C22.75 14.9901 22.75 14.7101 22.75 14.15V12.35C22.75 11.7899 22.75 11.5099 22.641 11.296C22.5451 11.1078 22.3922 10.9549 22.204 10.859C21.9901 10.75 21.7101 10.75 21.15 10.75H14.35C13.7899 10.75 13.5099 10.75 13.296 10.859C13.1078 10.9549 12.9549 11.1078 12.859 11.296C12.75 11.5099 12.75 11.7899 12.75 12.35V14.15C12.75 14.7101 12.75 14.9901 12.859 15.204C12.9549 15.3922 13.1078 15.5451 13.296 15.641C13.5099 15.75 13.7899 15.75 14.35 15.75H21.15Z"
				fill="currentColor"
			/>
			<path
				d="M2.58333 9.25H12H21.4167C21.7267 9.25 21.8817 9.25 22.0088 9.21593C22.3539 9.12346 22.6235 8.85391 22.7159 8.50882C22.75 8.38165 22.75 8.22666 22.75 7.91667C22.75 6.36671 22.75 5.59174 22.5796 4.9559C22.1173 3.23044 20.7696 1.88271 19.0441 1.42037C18.4083 1.25 17.6333 1.25 16.0833 1.25H7.91667C6.36671 1.25 5.59174 1.25 4.9559 1.42037C3.23044 1.88271 1.88271 3.23044 1.42037 4.9559C1.25 5.59174 1.25 6.36671 1.25 7.91667C1.25 8.22666 1.25 8.38165 1.28407 8.50882C1.37654 8.85391 1.64609 9.12346 1.99118 9.21593C2.11835 9.25 2.27334 9.25 2.58333 9.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
